import { render, staticRenderFns } from "./OverridePaediatricAge.vue?vue&type=template&id=68b416a8"
import script from "./OverridePaediatricAge.vue?vue&type=script&lang=ts"
export * from "./OverridePaediatricAge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/organs/kidney/_locales/OverridePaediatricAge.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Forgans%2Fkidney%2FOverridePaediatricAge.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports